import {NgModule} from '@angular/core';
import {ClickOutsideDirective} from './click-outside.directive';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    declarations: [ClickOutsideDirective],
    exports: [ClickOutsideDirective],
})
export class ClickOutsideModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/events/click-outside/click-outside.module.ts